import { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { CircleDollarSign, ShieldCheck, Sparkles, TrendingUp } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import api, { extractError } from "../lib/api";

export default function Login() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [config, setConfig] = useState({ public_registration: true });

  useEffect(() => {
    api.get("/auth/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  if (user) return <Navigate to={loc.state?.from?.pathname || "/"} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await login(email, password);
      nav(loc.state?.from?.pathname || "/", { replace: true });
    } catch (err) {
      console.error("Login failed:", err);
      setError(extractError(err, "Giriş başarısız"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="auth-shell" data-testid="login-page">
      <aside className="auth-hero">
        <div className="brand auth-brand">
          <div className="brand-mark"><CircleDollarSign size={20} /></div>
          <span>verafin</span>
        </div>
        <h1>Finansal nabzınız,<br />tek panelde.</h1>
        <p>Gelir, gider, banka hesapları, cari ilişkileri ve nakit akışı — hepsi anlık, hepsi bir arada.</p>
        <ul className="hero-list">
          <li><TrendingUp size={16} /> Anlık nakit akışı ve KPI takibi</li>
          <li><Sparkles size={16} /> Modern raporlar ve kategori analizi</li>
          <li><ShieldCheck size={16} /> KVKK uyumlu, çok şirketli yapı</li>
        </ul>
        <div className="hero-badge">Türk KOBİ'leri için tasarlandı · TRY</div>
      </aside>

      <section className="auth-card-wrap">
        <form className="auth-card" onSubmit={submit}>
          <div className="eyebrow">GİRİŞ</div>
          <h2>Tekrar hoş geldiniz</h2>
          <p className="auth-sub">Çalışma alanınıza erişmek için bilgilerinizi girin.</p>

          <label>
            E-posta
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              autoComplete="email"
              required
              data-testid="login-email-input"
              placeholder="you@company.com"
            />
          </label>
          <label>
            Parola
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
              data-testid="login-password-input"
              placeholder="••••••••"
            />
          </label>

          {error ? <div className="form-error" data-testid="login-error">{error}</div> : null}

          <button className="primary-btn full" disabled={busy} data-testid="login-submit-button">
            {busy ? "Giriş yapılıyor…" : "Giriş yap"}
          </button>

          <div className="auth-secondary-link">
            <Link to="/forgot-password" data-testid="forgot-password-link">Şifremi unuttum</Link>
          </div>

          <div className="auth-foot">
            {config.public_registration ? (
              <>Hesabınız yok mu? <Link to="/register" data-testid="go-register-link">Kayıt olun</Link></>
            ) : (
              <>Yeni kayıt kapalı · Davet linkiniz varsa e-postadaki bağlantıyı kullanın.</>
            )}
          </div>

          <div className="auth-demo">
            <strong>Demo hesap</strong>
            <span>admin@verafin.com / Admin123!</span>
          </div>
        </form>
      </section>
    </div>
  );
}
